
export default class Column {

  public name: string;
  public isSorted: boolean;
  public width?: string;

  constructor(name: string, isSorted: boolean, width?: string) {
    this.name = name;
    this.isSorted = isSorted;
    this.width = width;
  }

}
